module.exports = __webpack_public_path__ + "static/media/DAI-BUSD.146652c3.png";